// TODO: extract into shared repo
import moment from "moment";

export function getAllSessionDates(items: { date: string }[]) {
  return items
    .map((session) => moment(session.date, "YYYY-MM-DD"))
    .filter((date) => date.isValid());
}

export function getMaxSessionDate(
  allSessionDates: moment.Moment[],
  today: moment.Moment
) {
  return allSessionDates.length > 0 ? moment.max(allSessionDates) : today;
}

export function getAllDateStrings(
  today: moment.Moment,
  maxSessionDate: moment.Moment
) {
  return maxSessionDate.isSameOrAfter(today, "day")
    ? getDateRangeWithFormat(today, maxSessionDate, "YYYY-MM-DD")
    : [];
}

export function getSessionDateStrings(items: { date: string }[]) {
  return items.map((session) => session.date);
}

export function getEarliestAvailableIndex(
  allDateStrings: string[],
  sessionDateStrings: string[]
) {
  return allDateStrings.findIndex((date) => sessionDateStrings.includes(date));
}

export function getDateRangeWithFormat(
  minDate: moment.Moment,
  maxDate: moment.Moment,
  format: string = "YYYY-MM-DD"
): string[] {
  const dates: string[] = [];
  let current = minDate.clone();
  while (current.isSameOrBefore(maxDate, "day")) {
    // Exclude Saturdays (6) and Sundays (0)
    if (current.day() !== 0 && current.day() !== 6) {
      dates.push(current.format(format));
    }
    current.add(1, "day");
  }
  return dates;
}

export function filterSessionsByDate<T extends { date: string }>(
  items: T[],
  selectedDate?: string
): T[] {
  return selectedDate
    ? items.filter((session) => session.date === selectedDate)
    : items;
}

export function getFormattedDateLabel(dateString: string): string {
  const sessionDate = moment(dateString, "YYYY-MM-DD");
  return sessionDate.format("dddd Do MMMM");
}

export function groupContentByDate<T extends { date: string; time?: string }>(
  items: T[]
): Array<{ date: string; dateLabel: string; sessions: T[] }> {
  // First, group by date string
  const grouped = items.reduce((acc, item) => {
    const dateKey = item.date;
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(item);
    return acc;
  }, {} as Record<string, T[]>);

  // Convert to array and sort by date
  const dateGroups = Object.entries(grouped)
    .map(([date, sessions]) => ({
      date,
      dateLabel: getFormattedDateLabel(date),
      sessions,
    }))
    .sort((a, b) => {
      // Sort date groups chronologically
      return moment(a.date, "YYYY-MM-DD").diff(moment(b.date, "YYYY-MM-DD"));
    });

  return dateGroups;
}
